<template>
  <div>
   

    <b-form-group
      label="Tab Name"
      label-for="tabName"
    >
      <b-form-input
        id="tabName"
        ref="tabName"
        v-model="tabName"
        placeholder="Enter Tab Name"
      />
    </b-form-group>
    <div
      v-if="tabs.length > 0"
      style="display:flex"
    >
      <b-form-radio
        v-model="tabAction"
        name="tabAction"
        value="new"
        class="mr-2"
      >
        New Tab
      </b-form-radio>
      <b-form-radio
        v-model="tabAction"
        name="tabAction"
        value="duplicate"
        class="mr-2"
      >
        Duplicate Tab
      </b-form-radio>
      <!-- <b-form-radio
          v-model="tabAction"
          name="tabAction"
          value="link"
          class="mr-2"
        >
          Link Tab
        </b-form-radio> -->
    </div>
    <div style="text-align: left;font-size: 13px; margin-top: 12px;">
      Server: <strong> {{ server_selected }}</strong>
    </div>
    <div
      v-if="tabAction === 'new'"
      style="height: 300px;"
    >
      <!-- <h5 class="mb-1 mt-2">
          Server Selection
        </h5>
        <b-button
          v-for="(item, index) in servers"
          :key="`server_${index}`"
          :variant="`${(server === item.id) ? 'primary' : 'outline-primary'}`"
          class="mr-1 mb-1"
          @click="server = item.id"
        >
          <feather-icon
            icon="ServerIcon"
            class="mr-1"
          />
          {{ item.id }}
        </b-button>
        <h5 class="mb-1 mt-2">
          Viewer types
        </h5>
        <b-row>
          <b-col
            v-for="(item, index) in types"
            :key="`type_${index}`"
            xl="3"
            lg="6"
          >
            <b-card
              class="viewer-card"
              :title="item.name"
              :img-src="item.image"
              :img-alt="item.name"
              img-top
              tag="article"
              style="max-width: 20rem;"
            >
              <b-card-text style="font-size: 90%">
                {{ item.description }}
              </b-card-text> -->

      <b-button
        style="margin-top:20px; display: block;"
        variant="outline-primary"
        :disabled="tabName === ''"
        @click="createViewer('server_KID')"
      >
        Add this Viewer
      </b-button>
      <!-- </b-card>
          </b-col>
        </b-row> -->
    </div>
    <div
      v-if="tabAction === 'duplicate'"
      style="min-height: 530px"
    >
      <h5 class="mb-1 mt-2">
        Duplicable Tabs
      </h5>
      <b-row>
        <b-col
          v-for="(item, index) in tabs"
          :key="`duplicatetab_${index}`"
          xl="3"
          lg="6"
        >

          <b-card
            class="viewer-card"
            style="max-width: 20rem;"
            no-body
          >
            <div
              style="background: black; display: flex; justify-content: center;"
            >
              <img
                :src="(item.image !== null && item.image !== '') ? `data:image/jpeg;base64,${item.image}` : item.type_image"
                :alt="item.name"
                style="width:auto; height:116px"
                class="card-img-top"
              >
            </div>
            <div
              class="card-body"
              style="display: flex; flex-direction: column;"
            >
              <b-card-title>{{ item.name }}</b-card-title>
              <b-card-sub-title class="mb-2">
                {{ item.type_name }}
              </b-card-sub-title>

              <b-button
                style="display: block;"
                variant="outline-primary"
                :disabled="tabName === ''"
                @click="duplicateViewer(item.id)"
              >
                Duplicate this Tab
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div
      v-if="tabAction === 'link'"
      style="min-height: 530px"
    >
      <h5 class="mb-1 mt-2">
        Linkable Tabs
      </h5>
      <b-row>
        <b-col
          v-for="(item, index) in tabs"
          :key="`linktab_${index}`"
          xl="3"
          lg="6"
        >
          <b-card
            class="viewer-card"
            style="max-width: 20rem;"
            no-body
          >
            <div
              style="background: black; display: flex; justify-content: center;"
            >
              <img
                :src="(item.image !== null && item.image !== '') ? `data:image/jpeg;base64,${item.image}` : item.type_image"
                :alt="item.name"
                style="width:auto; height:116px"
                class="card-img-top"
              >
            </div>
            <div
              class="card-body"
              style="display: flex; flex-direction: column;"
            >
              <b-card-title>{{ item.name }}</b-card-title>
              <b-card-sub-title class="mb-2">
                {{ item.type_name }}
              </b-card-sub-title>
              <b-button
                style="display: block;"
                variant="outline-primary"
                :disabled="tabName === ''"
                @click="linkViewer(item.id)"
              >
                Link this Tab
              </b-button>
            </div></b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  BFormInput, BFormGroup, BRow, BCol, BCard, BButton, BCardText, BFormRadio,
} from 'bootstrap-vue'
import Popover from 'vue-js-popover'
import store from '@/store/index'
import axios from 'axios'

const { url, port, auth } = store.state.appConfig.api
const headers = {
  authentication: auth,
  'Content-Type': 'application/json',
}

Vue.use(Popover)

export default {
  components: {
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    BButton,
    BCardText,
    BFormRadio,
  },
  directives: {},
  props: {
    tabkey: {
      required: true,
      type: Number,
    },
    server_selected: {
      required: true,
      type: String,
    },
    tabs: {
      required: true,
      type: [Array, Object, String],
      default: () => [],
    },
  },
  data() {
    return {
      serverContent: null,
      tabName: '',
      server: '',
      servers: [],
      types: [],
      loaded: false,
      loader: '',
      tabAction: 'new',
    }
  },
  computed: {
    disabled() {
      return (this.tabName === '' || this.server === '')
    },
  },
  mounted() {
    this.getTypes()
  },
  methods: {
    getTypes() {
      const { id } = this.$route.params
      axios.get(`${url}:${port}/viewer-types/${id}`, { headers }).then(response => {
        if (response) {
          const { types, servers } = response.data
          this.types = types
          this.servers = servers
          this.loaded = true
        }
      })
    },
    async createViewer(type) {
      console.log('VIEWER TYPE IS', type)
      // this.loader = 'loader'
      const { id } = this.$route.params
      const { tabName, server_selected } = this
      const data = { tabName, type }
      data.type = 'marker_overlaper'

      data.server = server_selected
     // data.server = server
      console.log('ENVIOS', data)
      localStorage.setItem('new_tab', 1)

      await axios.post(`${url}:${port}/viewer-create/${id}`, JSON.stringify(data), { headers }).then(response => {
        if (response) {
          this.$root.$refs.viewer.isLoading = true
          // setTimeout(function() {
          //              document.location.reload()
          //        }, 3000);
        }
      })
    },
    duplicateViewer(duplicated) {
      this.loader = 'loader'
      const { id } = this.$route.params
      const { tabName } = this
      const data = { tabName, duplicated }
      axios.post(`${url}:${port}/viewer-duplicate/${id}`, JSON.stringify(data), { headers }).then(response => {
        if (response) {
          setTimeout(() => {
            document.location.reload()
          }, 10000)
        }
      })
    },
    linkViewer(linked) {
      this.loader = 'loader'
      const { id } = this.$route.params
      const { tabName } = this
      const data = { tabName, linked }
      axios.post(`${url}:${port}/viewer-linktab/${id}`, JSON.stringify(data), { headers }).then(response => {
        if (response) {
          setTimeout(() => {
            document.location.reload()
          }, 10000)
        }
      })
    },
  },
}

</script>
<style>
[data-popover='foo'] {
  font-size: 12px;
  line-height: 1.5;
  margin-top: 0px;
  position:fixed;
}
.viewer-card{
  border: 1px solid #ccc
}
.loader{
  opacity: 0.5
}
</style>
